export default __webpack_public_path__ + "static/newsletter-fc47d525ed346454053880b7b445ffd4.jpg";